import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_TEMPLATE_EDITOR_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_TEMPLATE_EDITOR_SCHEMA);
const KEYS: any = generateKeys(TRACKING_TEMPLATE_EDITOR_SCHEMA);

export class TemplateEditorTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.template_editor;
  }

  get properties() {
    return this.toJS();
  }
}
